module.exports = __webpack_public_path__ + "img/12.f1c70e58.jpg";